var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatePickerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5.5C4.44772 5.5 4 5.94772 4 6.5V20.5C4 21.0523 4.44772 21.5 5 21.5H19C19.5523 21.5 20 21.0523 20 20.5V6.5C20 5.94772 19.5523 5.5 19 5.5H5ZM2 6.5C2 4.84315 3.34315 3.5 5 3.5H19C20.6569 3.5 22 4.84315 22 6.5V20.5C22 22.1569 20.6569 23.5 19 23.5H5C3.34315 23.5 2 22.1569 2 20.5V6.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1.5C16.5523 1.5 17 1.94772 17 2.5V6.5C17 7.05228 16.5523 7.5 16 7.5C15.4477 7.5 15 7.05228 15 6.5V2.5C15 1.94772 15.4477 1.5 16 1.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.5C8.55228 1.5 9 1.94772 9 2.5V6.5C9 7.05228 8.55228 7.5 8 7.5C7.44772 7.5 7 7.05228 7 6.5V2.5C7 1.94772 7.44772 1.5 8 1.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10.5C2 9.94771 2.44772 9.5 3 9.5H21C21.5523 9.5 22 9.94771 22 10.5C22 11.0523 21.5523 11.5 21 11.5H3C2.44772 11.5 2 11.0523 2 10.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePickerIcon);
export default __webpack_public_path__ + "static/media/date-picker-icon.e577aa813fe1eb0701046e8039fc9974.svg";
export { ForwardRef as ReactComponent };